<template>
  <el-tooltip effect="light" :visible-arrow="false">
    <template #content>
      <slot />
    </template>
    <button class="tooltip-reference">
      <svg-icon name="info" />
    </button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'Tooltip'
}
</script>

<style lang="scss">
.el-tooltip__popper {
  max-width: 320px;
  background: $white;
  box-shadow: 0 0 16px rgba($deepdark, 0.12) !important;
  border-radius: 12px !important;
  border: 0 !important;
  text-align: center;
}

.tooltip-reference {
  width: 16px;
  height: 16px;
  cursor: help;

  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
